/**
 * Created by razial on 17.09.2026
 */

const PersonsGalleryWindow = cc.Node.extend({
    ctor: function (onClose, emotion) {
        this._super();

        this.onClose = onClose;
        this.emotion = emotion || "idle";

        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setContentSize(sceneSize);
        this.setAnchorPoint(0, 0);

        const personBundles = Object.keys(cleverapps.config.persons).map((g) => `persons_${g}`);

        cleverapps.bundleLoader.loadBundles(personBundles.concat("persons_gallery_window"), {
            onSuccess: this.createContent.bind(this)
        });

        cleverapps.Scenes.GetRunningScene().addChild(this, 1000);
        this.setAlignment({ align: "left" }, { align: "bottom" });
        cleverapps.focusManager.setEventNodes([this]);
    },

    createContent: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        const { personSpacing } = cleverapps.styles.PersonsGalleryWindow;
        const dialogueStyles = cleverapps.styles.DialogueViewHorizontal;
        const bgHeight = dialogueStyles.size[cleverapps.resolution.mode].height;
        const safePadding = cleverapps.resolution.getSafePadding();
        const personStyles = dialogueStyles.persons;
        const scale = [personStyles.mobileScale, personStyles.squareScale, 1][cleverapps.resolution.mode];
        const personY = dialogueStyles.offsetY + bgHeight + personStyles.offsetY * scale;

        const personsData = cleverapps.persons.getData();
        const aliasRoles = ["hero", "narrator"];
        const seenNames = {};
        const roles = Object.keys(personsData)
            .filter((role) => !aliasRoles.includes(role))
            .filter((role) => {
                const name = personsData[role].name;
                if (seenNames[name]) {
                    return false;
                }
                seenNames[name] = true;
                return true;
            });

        const createPerson = (role) => {
            const person = new Person({ role, emotion: this.emotion });

            if (!person.hasAnimation(this.emotion)) {
                return;
            }

            const cell = new cc.Node();
            cell.setContentSize(personSpacing, sceneSize.height);
            cell.setAnchorPoint(0, 0);

            person.setAnchorPoint(0.5, 0);
            person.setScale(scale);

            const personAnchorBone = person.getBone("person_anchor");
            const adjustedPersonY = personAnchorBone
                ? dialogueStyles.offsetY + bgHeight - (person.height / 2 + personAnchorBone.y * resolutionScale) * scale
                : personY;
            person.setPosition(personSpacing / 2, adjustedPersonY);
            cell.addChild(person);

            const title = cleverapps.UI.generateOnlyText(role, cleverapps.styles.FONTS.STRICT_WHITE_TEXT);
            title.setPosition(personSpacing / 2, dialogueStyles.offsetY + bgHeight);
            cell.addChild(title);

            return cell;
        };

        const prefabNode = Prefab.instantiate(bundles.persons_gallery_window.jsons.persons_gallery_window_prefab_json, {
            roles,
            createPerson,
            close: this.close.bind(this)
        });

        prefabNode.setContentSize(sceneSize);
        const bg = prefabNode.getChildByName("bg");
        bg.setContentSize(sceneSize.width, bgHeight + safePadding.bottom);
        bg.setAlignment({ align: "left" }, { align: "bottom", dy: dialogueStyles.offsetY - safePadding.bottom });
        const scroll = prefabNode.getChildByName("scroll");
        scroll.setContentSize(sceneSize.width, sceneSize.height);
        scroll.scrollToDefault();
        this.addChild(prefabNode);
    },

    close: function () {
        this.removeFromParent();
        this.onClose();
    }
});

cleverapps.styles.PersonsGalleryWindow = {
    personSpacing: 480
};
